import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { CreditType, FocusInputType, LocalService, NumericConfig, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';

@Component({
  selector: 'app-edit-credits',
  templateUrl: './edit-credits.component.html',
  styleUrls: ['./edit-credits.component.scss']
})
export class EditCreditsComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["edit_credits"]; id: string; isAddCredit: boolean = null; currentCredits: string; credit: number = null; notes: string = '';
  creditType: CreditType = CreditType.None; currentCreditsValue: number; isCurrentCreditNegative: boolean = false; message: string = ''; isRedAlert: boolean = true; maxBodyHeight = 0;
  elementIds: any = {
    new_credits: 'new_credits',
    new_credits_note: 'new_credits_note',
    btn_save_credit: 'btn_save_credit'
  };
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;

  constructor(private activeModal: NgbActiveModal, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, public localService: LocalService, public profileManagementService: ProfileManagementService) { }

  ngOnInit(): void {
    this.isCurrentCreditNegative = this.currentCredits.indexOf("-") > -1;
    this.currentCreditsValue = this.isCurrentCreditNegative ? -parseFloat(this.currentCredits) : parseFloat(this.currentCredits);
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    if (this.doCheck()) {
      this.profileManagementService.saveCredits(this.id, this.credit, this.isAddCredit, this.creditType, this.notes, '').subscribe(result => {
        if (result.status == Status.Success) {
          this.activeModal.close({ event: TriggeredEvent.Ok, currentCredits: result.id });
        }        
      });
    }
  }

  doCheck() {
    this.message = '';
    if (this.isAddCredit == null) {
      this.message = this.localService.languageContent.edit_credits.type_required;
    } else if (this.credit == null || this.credit <= 0) {
      this.message = this.localService.languageContent.edit_credits.invalid_amount;
    }
    return this.message == '' && this.creditType != CreditType.None;
  }

  onRadioChecked(index: number) {
    this.message = '';
    switch (index) {
      case 1: {
        this.isAddCredit = true;
      } break;
      case 2: {
        this.isAddCredit = false;
      } break;
    }
    this.localService.onFocusNextInput(this.elementIds.new_credits, FocusInputType.TextBox, true);
  }
}
